import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, Route, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SnackbarService } from '../services/snackbar.service';

const checkRole = (
    route: Route | ActivatedRouteSnapshot,
    router: Router,
    authService: AuthService,
    snackbarService: SnackbarService
) => {
    const user = authService.user();
    if (!user) {
        return router.parseUrl('/login');
    }

    const allowedRoles = route.data?.['roles'] as string[];
    if (!allowedRoles || allowedRoles.length === 0) {
        return true;
    }

    if (allowedRoles.includes(user.role)) {
        return true;
    }

    // Redirect to dashboard with unauthorized notification
    snackbarService.show({
        type: 'error',
        message: 'You do not have permission to access this page.'
    });
    return router.parseUrl('/dashboard');
};

export const roleGuard: CanActivateFn = (route, state) => {
    return checkRole(route, inject(Router), inject(AuthService), inject(SnackbarService));
};

export const roleMatchGuard: CanMatchFn = (route, segments) => {
    return checkRole(route, inject(Router), inject(AuthService), inject(SnackbarService));
};
